export enum mxStateCode {
  AGU = 'AGU',
  BCN = 'BCN',
  BCS = 'BCS',
  CAM = 'CAM',
  CHP = 'CHP',
  CHH = 'CHH',
  COA = 'COA',
  COL = 'COL',
  CMX = 'CMX',
  DUR = 'DUR',
  GUA = 'GUA',
  GRO = 'GRO',
  HID = 'HID',
  JAL = 'JAL',
  MEX = 'MEX',
  MIC = 'MIC',
  MOR = 'MOR',
  NAY = 'NAY',
  NLE = 'NLE',
  OAX = 'OAX',
  PUE = 'PUE',
  QUE = 'QUE',
  ROO = 'ROO',
  SLP = 'SLP',
  SIN = 'SIN',
  SON = 'SON',
  TAB = 'TAB',
  TAM = 'TAM',
  TLA = 'TLA',
  VER = 'VER',
  YUC = 'YUC',
  ZAC = 'ZAC'
}

export const mxStateCodeToNameMap = {
  [mxStateCode.AGU]: 'Aguascalientes',
  [mxStateCode.BCN]: 'Baja California',
  [mxStateCode.BCS]: 'Baja California Sur',
  [mxStateCode.CAM]: 'Campeche',
  [mxStateCode.CHP]: 'Chiapas',
  [mxStateCode.CHH]: 'Chihuahua',
  [mxStateCode.COA]: 'Coahuila',
  [mxStateCode.COL]: 'Colima',
  [mxStateCode.CMX]: 'Ciudad de México',
  [mxStateCode.DUR]: 'Durango',
  [mxStateCode.GUA]: 'Guanajuato',
  [mxStateCode.GRO]: 'Guerrero',
  [mxStateCode.HID]: 'Hidalgo',
  [mxStateCode.JAL]: 'Jalisco',
  [mxStateCode.MEX]: 'México',
  [mxStateCode.MIC]: 'Michoacán',
  [mxStateCode.MOR]: 'Morelos',
  [mxStateCode.NAY]: 'Nayarit',
  [mxStateCode.NLE]: 'Nuevo León',
  [mxStateCode.OAX]: 'Oaxaca',
  [mxStateCode.PUE]: 'Puebla',
  [mxStateCode.QUE]: 'Querétaro',
  [mxStateCode.ROO]: 'Quintana Roo',
  [mxStateCode.SLP]: 'San Luis Potosí',
  [mxStateCode.SIN]: 'Sinaloa',
  [mxStateCode.SON]: 'Sonora',
  [mxStateCode.TAB]: 'Tabasco',
  [mxStateCode.TAM]: 'Tamaulipas',
  [mxStateCode.TLA]: 'Tlaxcala',
  [mxStateCode.VER]: 'Veracruz',
  [mxStateCode.YUC]: 'Yucatán',
  [mxStateCode.ZAC]: 'Zacatecas'
}

export const mxStates = [
  { value: mxStateCode.AGU, label: mxStateCodeToNameMap.AGU },
  { value: mxStateCode.BCN, label: mxStateCodeToNameMap.BCN },
  { value: mxStateCode.BCS, label: mxStateCodeToNameMap.BCS },
  { value: mxStateCode.CAM, label: mxStateCodeToNameMap.CAM },
  { value: mxStateCode.CHP, label: mxStateCodeToNameMap.CHP },
  { value: mxStateCode.CHH, label: mxStateCodeToNameMap.CHH },
  { value: mxStateCode.COA, label: mxStateCodeToNameMap.COA },
  { value: mxStateCode.COL, label: mxStateCodeToNameMap.COL },
  { value: mxStateCode.CMX, label: mxStateCodeToNameMap.CMX },
  { value: mxStateCode.DUR, label: mxStateCodeToNameMap.DUR },
  { value: mxStateCode.GUA, label: mxStateCodeToNameMap.GUA },
  { value: mxStateCode.GRO, label: mxStateCodeToNameMap.GRO },
  { value: mxStateCode.HID, label: mxStateCodeToNameMap.HID },
  { value: mxStateCode.JAL, label: mxStateCodeToNameMap.JAL },
  { value: mxStateCode.MEX, label: mxStateCodeToNameMap.MEX },
  { value: mxStateCode.MIC, label: mxStateCodeToNameMap.MIC },
  { value: mxStateCode.MOR, label: mxStateCodeToNameMap.MOR },
  { value: mxStateCode.NAY, label: mxStateCodeToNameMap.NAY },
  { value: mxStateCode.NLE, label: mxStateCodeToNameMap.NLE },
  { value: mxStateCode.OAX, label: mxStateCodeToNameMap.OAX },
  { value: mxStateCode.PUE, label: mxStateCodeToNameMap.PUE },
  { value: mxStateCode.QUE, label: mxStateCodeToNameMap.QUE },
  { value: mxStateCode.ROO, label: mxStateCodeToNameMap.ROO },
  { value: mxStateCode.SLP, label: mxStateCodeToNameMap.SLP },
  { value: mxStateCode.SIN, label: mxStateCodeToNameMap.SIN },
  { value: mxStateCode.SON, label: mxStateCodeToNameMap.SON },
  { value: mxStateCode.TAB, label: mxStateCodeToNameMap.TAB },
  { value: mxStateCode.TAM, label: mxStateCodeToNameMap.TAM },
  { value: mxStateCode.TLA, label: mxStateCodeToNameMap.TLA },
  { value: mxStateCode.VER, label: mxStateCodeToNameMap.VER },
  { value: mxStateCode.YUC, label: mxStateCodeToNameMap.YUC },
  { value: mxStateCode.ZAC, label: mxStateCodeToNameMap.ZAC }
]
